import { FuseUtils } from '@fuse';

function AnotacaoModel(data) {
    const item = data ? data : {};
    return {
        id: item.id || FuseUtils.generateGUID(),
        titulo: item.titulo || '',
        descricao: item.descricao || '',
        arquivado: item.arquivado || false,
        usrupt: item.usrupt || sessionStorage.getItem("displayname"),
        dataupt: item.dataupt || null,
        checklist: item.checklist || []
    }
}

export default AnotacaoModel;
